import { Center, VStack, Heading, Text } from "@chakra-ui/react";
import { type ReactNode } from "react";

import { useSecondaryTextColor } from "theme";

interface IProps {
  image: ReactNode;
  heading: string;
  subheading: string;
  children: ReactNode;
}

const Result = ({ children, heading, image, subheading }: IProps) => {
  const secondaryColor = useSecondaryTextColor();

  return (
    <Center minH="75vh" textAlign="center">
      <VStack gap={6}>
        {image}
        <VStack maxW="2xl">
          <Heading as="h2" size={{ base: "lg", md: "xl" }}>
            {heading}
          </Heading>
          <Text fontSize={{ base: "md", md: "lg" }} color={secondaryColor}>
            {subheading}
          </Text>
        </VStack>
        {children}
      </VStack>
    </Center>
  );
};

export { Result };
